import Theme from 'Theme';

export default {
    container: {
        padding: 20,
        backgroundColor: 'rgba(60, 60, 60, 0.95)',
        borderWidth: 2,
        alignSelf: 'center',
        margin: 'auto',
        borderRadius: 5
    },
    title: { color: 'white', fontSize: 26 },
    description: { color: 'white', paddingVertical: 5 },
    input: {
        fontFamily: Theme.regularFont,
        alignSelf: 'stretch',
        backgroundColor: '#FFFFFF',
        fontSize: 21,
        color: '#333333',
        height: 55,
        borderRadius: 3,
        paddingHorizontal: 12
    },
    buttonsContainer: { flexDirection: 'row', flex: 1, marginTop: 10, alignItems: 'space-between' }
};
